import http from './api'

const route = 'app/comercial/vendas/'

export default {
  showFaturamentoVendas: (dataInicio, dataFim, select, supervisor, vendedores, areas, redes, receita, tokenContrato, segmento, classificacoes, categoria, promotor) => {
    return http.post(route + 'showFaturamentoVendas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedor: vendedores,
      area: areas,
      rede: redes,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      classificacoes: classificacoes,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showFaturamentoMesAnoAnterior: (dataInicio, dataFim, select, supervisor, vendedores, areas, redes, receita, tokenContrato, segmento, classificacoes, categoria, promotor) => {
    return http.post(route + 'showFaturamentoMesAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedor: vendedores,
      area: areas,
      rede: redes,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      classificacoes: classificacoes,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showFaturamento7MesesAnteriores: (select, supervisor, vendedores, areas, redes, receita, tokenContrato, segmento, classificacoes, categoria, promotor) => {
    return http.post(route + 'showFaturamento7MesesAnteriores', {
      select: select,
      supervisor: supervisor,
      vendedor: vendedores,
      area: areas,
      rede: redes,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      classificacoes: classificacoes,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showFaturamentoMesesDoAno: (select, supervisor, vendedores, areas, redes, receita, tokenContrato, segmento, classificacoes, categoria, promotor) => {
    return http.post(route + 'showFaturamentoMesesDoAno', {
      select: select,
      supervisor: supervisor,
      vendedor: vendedores,
      area: areas,
      rede: redes,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      classificacoes: classificacoes,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showFaturamentoPrincipaisClientes: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFaturamentoPrincipaisClientes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoGrupoProdutos: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFaturamentoGrupoProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoProdutos: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFaturamentoProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showEvolucaoVendas: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showEvolucaoVendas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showEvolucaoVendasVendedores: (item, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showEvolucaoVendasVendedores', {
      item: item,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showEvolucaoVendasVolume: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showEvolucaoVendasVolumeSupervisor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showEvolucaoVendasVolumeVendedores: (item, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showEvolucaoVendasVolumeVendedores', {
      item: item,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDetalhePrincipaisClientes: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor) => {
    return http.post(route + 'showDetalhePrincipaisClientes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDelhamentoGrupoProdutos: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showDelhamentoGrupoProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoClassificacaoProdutos: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showFaturamentoClassificacaoProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoClassificacaoProdutos: (dataInicio, dataFim, select, supervisor, tokenContrato) => {
    return http.post(route + 'showDelhamentoClassificacaoProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoProdutos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDelhamentoProdutos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },
}
